import { Button, CircularProgress, Typography } from '@mui/material';
import React from 'react';

interface CaptureControlsProps {
 isCapturing: boolean;
 error: string | null;
 selectedSize: string;
 onCapture: () => void;
}

function CaptureControls({ isCapturing, error, selectedSize, onCapture }: CaptureControlsProps) {
 return (
   <div>
     <Button
       onClick={onCapture}
       disabled={isCapturing || !selectedSize}
       startIcon={isCapturing ? <CircularProgress size={20} /> : null}
       disableRipple
       variant="text"
       sx={{ padding: 0, "&:hover": { backgroundColor: "transparent" } }}
     >
       {isCapturing ? 'Capturing...' : 'Capture Preview'}
     </Button>
     
     {error && (
       <Typography color="error" variant="caption" display="block" sx={{ mt: 1 }}>
         {error}
       </Typography>
     )}
   </div>
 );
}

export default CaptureControls;